// extracted by mini-css-extract-plugin
export default {"maxWidth":"MaxWidth_maxWidth__k6OtW"};